import { useEffect, useState } from "react";
import { useUser } from "@/hooks/useUser"
import { useNavigate } from "react-router-dom";
import { getAuhtUrl } from "@/Api";
import { Header } from "react-frontier";

var AuthUser=()=>{
	var navigate=useNavigate();
   var {user,logout}=useUser();
   var [loginError,setLoginError]=useState<string>(null);

   useEffect(()=>{
      if(user){
			navigate('/dashboard')
			return
		}
      
		var authUrl=getAuhtUrl();
      if(!authUrl) return setLoginError('Hubo un error inesperado al cargar el inicio de sesion. (LCL-AUTHRP-1)')
      window.location.href=authUrl;
   },[user, navigate]);

	if(loginError){
		return <div style={{ marginTop: 20 }}>
			<Header text='Error' size='big' centered subtext={`Error inesperado: ${loginError}`} style={{ maxWidth: 500, margin: 'auto' }} />
			<div className="fr black basic button" style={{ margin: 'auto', display: 'block', width: 150, marginTop: 20 }} onClick={logout}>
				Intentar de nuevo
			</div>
		</div>
	}
	
	return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<div>Logo Arema</div>
	</div>
}

export default AuthUser;